import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { MessageStatus } from "../../models/message-status.model";

export namespace MessageStatusActions {

  @logDispatcher
  export class GetMessageStatus {
    static readonly type = '[MessageStatus] GetMessageStatus';
    constructor() { }
  }

  @logDispatcher
  export class GetMessageStatusSuccess {
    static readonly type = '[MessageStatus] GetMessageStatusSuccess';
    constructor(public messageStatus: MessageStatus[]) { }
  }

  @logDispatcher
  export class GetMessageStatusFail {
    static readonly type = '[MessageStatus] GetMessageStatusFail';
    constructor(public error: any) { }
  }
}
